import { render, staticRenderFns } from "./how.vue?vue&type=template&id=a8a0707c&"
import script from "./how.vue?vue&type=script&lang=js&"
export * from "./how.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports